import Button from "@mui/material/Button";
import { useNavigate } from "react-router";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";
import { DialogHeader } from "../../../auth/components/PasswordRecoveryModal";

export function NoChangesOnClientEditModal(props: {
  open: boolean;
  setOpen: (open: boolean) => void;
}) {
  const { open, setOpen } = props;
  const navigate = useNavigate();
  const onClose = () => setOpen(false);
  const onCancel = () => {
    onClose();
    navigate("/clients");
  };
  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogHeader id="customized-dialog-title" onClose={onClose}>
        Nenhuma alteração foi feita
      </DialogHeader>
      <DialogContent
        sx={{
          height: "100px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
        dividers
      >
        <Typography gutterBottom>
          Nenhuma alteração foi feita na edição do cliente. Deseja prosseguir ou
          continuar a edição?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Voltar para edição</Button>
        <Button variant="contained" color="primary" onClick={onCancel}>
          Prosseguir
        </Button>
      </DialogActions>
    </Dialog>
  );
}
